import { render, staticRenderFns } from "./AdditionalPropertyInput.vue?vue&type=template&id=67dee7b8&scoped=true&"
import script from "./AdditionalPropertyInput.vue?vue&type=script&lang=js&"
export * from "./AdditionalPropertyInput.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPropertyInput.vue?vue&type=style&index=0&id=67dee7b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dee7b8",
  null
  
)

export default component.exports